import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  FaChartBar,
  FaChevronRight,
  FaTruck,
  FaChartLine,
} from "react-icons/fa";

import Footer from "../components/Footer";

import gasto from "../images/gasto.png";
import egreso from "../images/egreso.png";
import cuota from "../images/cuota.jpg";
import rendicion from "../images/rendicion.png";
import orden from "../images/orden.png";
import tesoro from "../images/tesoro.png";
import peaje from "../images/peaje.png";
import auditoria from "../images/auditoria.jpg";
import chofer from "../images/chofer.jpg";
import estacion from "../images/estacion.png";
import papas from "../images/bolsa.png";
import cheque from "../images/cheque.png";
import combustible from "../images/combustible.png";
import dashcheque from "../images/dashcheque.jpg";

import "../css/home.css";
import "../css/footer.css";

/* =========================================================
   INFORMES
========================================================= */

const grupos = [
  {
    titulo: "Operación y transporte",
    descripcion:
      "Viajes, cargas, choferes y operación diaria",

    items: [
      {
        to: "/informecomandas",
        img: gasto,
        titulo: "Viajes",
        descripcion:
          "Detalle general de viajes",
      },
      {
        to: "/informeviajestransporte",
        img: gasto,
        titulo: "Viajes por transporte",
        descripcion:
          "Viajes agrupados por transporte",
      },
      {
        to: "/informectactechofer",
        img: chofer,
        titulo: "Ctas. Ctes. Choferes",
        descripcion:
          "Movimientos de cuenta corriente",
      },
      {
        to: "/informechoferes",
        img: chofer,
        titulo: "Obligaciones a choferes",
        descripcion:
          "Saldos y obligaciones pendientes",
      },
      {
        to: "/informeremitos",
        img: papas,
        titulo: "Papas",
        descripcion:
          "Remitos y movimientos de cargas",
      },
      {
        to: "/informepeajes",
        img: peaje,
        titulo: "Peajes",
        descripcion:
          "Consumos y análisis de peajes",
      },
      {
        to: "/informeseguros",
        icon: FaChartBar,
        titulo: "Seguros",
        descripcion:
          "Pólizas, vehículos y vencimientos",
        tipo: "seguro",
      },
      {
        to: "/dashboardrentabilidad",
        icon: FaChartBar,
        titulo: "Dashboard rentabilidad",
        descripcion: "Resultado de viajes propios y terceros",
      },
      {
        to: "/dashboardcombustible",
        img: combustible,
        titulo: "Dashboard combustible",
        descripcion:
          "Consumos y análisis de combustible",
      },
      {
        to: "/dashboardviajes",
        icon: FaTruck,
        titulo: "Dashboard viajes",
        descripcion: "Consulta por viaje, fechas, chofer y transporte",
        tipo: "dashboard-viajes",
      },
      {
        to: "/historicoviajes",
        icon: FaChartLine,
        titulo: "Histórico de viajes",
        descripcion: "Cantidad mensual de viajes por año, chofer y transporte",
        tipo: "historico-viajes",
      },

    ],
  },

  {
    titulo: "Finanzas y tesorería",
    descripcion:
      "Cajas, pagos, cuentas corrientes y cartera",

    items: [
      {
        to: "/informecajas",
        img: cuota,
        titulo: "Cajas",
        descripcion:
          "Movimientos y saldos de cajas",
      },
      {
        to: "/informemovimientos",
        img: egreso,
        titulo: "Movimientos",
        descripcion:
          "Ingresos, egresos y transferencias",
      },
      {
        to: "/informerendiciones",
        img: rendicion,
        titulo: "Rendiciones",
        descripcion:
          "Liquidaciones y comprobantes",
      },
      {
        to: "/informeordencobro",
        img: orden,
        titulo: "Órdenes de cobro",
        descripcion:
          "Cobros registrados",
      },
      {
        to: "/informeordenpago",
        img: orden,
        titulo: "Órdenes de pago",
        descripcion:
          "Pagos y obligaciones",
      },
      {
        to: "/informectacte",
        img: tesoro,
        titulo: "Ctas. Ctes. Cliente / Proveedor",
        descripcion:
          "Detalle de cuentas corrientes",
      },
      {
        to: "/informeclipro",
        img: tesoro,
        titulo: "Saldos Cliente / Proveedor",
        descripcion:
          "Saldos consolidados",
      },
      {
        to: "/informetesoreria",
        img: tesoro,
        titulo: "Tesorería",
        descripcion:
          "Situación financiera general",
      },
    ],
  },

  {
    titulo: "Estaciones y valores",
    descripcion:
      "Combustible, estaciones, cheques y eCheq",

    items: [
      {
        to: "/informectacteestacion",
        img: estacion,
        titulo: "Ctas. Ctes. Estaciones",
        descripcion:
          "Movimientos por estación",
      },
      {
        to: "/informeestaciones",
        img: estacion,
        titulo: "Saldos Estaciones",
        descripcion:
          "Saldos de estaciones de servicio",
      },
      {
        to: "/informecartera",
        img: cheque,
        titulo: "Cartera Cheques / eCheq",
        descripcion:
          "Valores disponibles en cartera",
      },
      {
        to: "/informe-cheques-echeq",
        img: cheque,
        titulo: "Resumen Cheques / eCheq",
        descripcion:
          "Estado consolidado de valores",
      },
      {
        to: "/informevencimientoschequesecheq",
        img: dashcheque,
        titulo: "Vencimientos Cheques / eCheq",
        descripcion:
          "Próximos vencimientos",
      },
      {
        to: "/dashboardchequesecheq",
        img: dashcheque,
        titulo: "Dashboard Cheques / eCheq",
        descripcion:
          "Panel gráfico de vencimientos",
      },
    ],
  },

  {
    titulo: "Control y auditoría",
    descripcion:
      "Seguimiento de acciones y control del sistema",

    items: [
      {
        to: "/informeauditoria",
        img: auditoria,
        titulo: "Auditoría",
        descripcion:
          "Registro detallado de operaciones",
      },
      {
        to: "/dashboardauditoria",
        img: auditoria,
        titulo: "Dashboard Auditoría",
        descripcion:
          "Indicadores y actividad de usuarios",
      },
    ],
  },
];

/* =========================================================
   CARD
========================================================= */

const InformeCard = ({
  item,
}) => {
  const Icon =
    item.icon;

  return (
    <Link
      to={item.to}
      className={`danlu-report-card ${
        item.tipo || ""
      }`}
    >
      <div className="danlu-report-icon">
        {item.img ? (
          <img
            src={item.img}
            alt={item.titulo}
          />
        ) : (
          <Icon />
        )}
      </div>

      <div className="danlu-report-body">
        <h3>
          {item.titulo}
        </h3>

        <p>
          {item.descripcion}
        </p>
      </div>

      <div className="danlu-report-arrow">
        <FaChevronRight />
      </div>
    </Link>
  );
};

/* =========================================================
   HOME INFORMES
========================================================= */

const HomeImpresion = () => {
  const totalInformes =
    grupos.reduce(
      (
        acc,
        grupo
      ) =>
        acc +
        grupo.items.length,
      0
    );

  return (
    <>
      <main className="danlu-menu-page">
        {/* HERO */}

        <section className="danlu-menu-hero informes">
          <div className="danlu-menu-hero-icon">
            <FaChartBar />
          </div>

          <div>
            <span className="danlu-menu-eyebrow">
              REPORTES Y ANÁLISIS
            </span>

            <h1>
              Informes
            </h1>

            <p>
              Consultas, reportes,
              tableros y análisis de
              información de Transporte DANLU
            </p>
          </div>
        </section>

        {/* RESUMEN */}

        <div className="danlu-menu-section-title">
          <div>
            <h2>
              Centro de informes
            </h2>

            <p>
              Los reportes están agrupados
              por área para encontrarlos más rápido
            </p>
          </div>

          <span>
            {totalInformes} informes
          </span>
        </div>

        {/* GRUPOS */}

        {grupos.map(
          (grupo) => (
            <section
              className="danlu-report-section"
              key={
                grupo.titulo
              }
            >
              <div className="danlu-report-section-header">
                <div>
                  <h2>
                    {grupo.titulo}
                  </h2>

                  <p>
                    {
                      grupo.descripcion
                    }
                  </p>
                </div>

                <span>
                  {
                    grupo.items
                      .length
                  }{" "}
                  opciones
                </span>
              </div>

              <div className="danlu-report-grid">
                {grupo.items.map(
                  (item) => (
                    <InformeCard
                      key={
                        item.to
                      }
                      item={
                        item
                      }
                    />
                  )
                )}
              </div>
            </section>
          )
        )}
      </main>

      <Footer />
    </>
  );
};

export default HomeImpresion;